// Halaman Hubungkan channel (2026-10-08): pagination daftar akun (10 per halaman) dan riwayat
// koneksi (terhubung / terhubung ulang / terputus sendiri / dihapus) dari /api/connections/history.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = process.env.REACT_APP_API_URL || 'https://api.sm-media.id';
export const PAGE_SIZE = 10;

export function pageSlice(list, page) {
  const pages = Math.max(1, Math.ceil((list || []).length / PAGE_SIZE));
  const p = Math.min(Math.max(1, page), pages);
  return (list || []).slice((p - 1) * PAGE_SIZE, p * PAGE_SIZE);
}

export function Pager({ total, page, onChange }) {
  const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  if (pages <= 1) return null;
  const p = Math.min(Math.max(1, page), pages);
  const btn = disabled => ({ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: `1px solid ${colors.border}`,
    background: colors.bgCard, color: disabled ? colors.textSecondary : colors.textPrimary, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.5 : 1 });
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 12, color: colors.textSecondary }}>
        {(p - 1) * PAGE_SIZE + 1}–{Math.min(p * PAGE_SIZE, total)} dari {total}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button style={btn(p <= 1)} disabled={p <= 1} onClick={() => onChange(p - 1)}>‹ Sebelumnya</button>
        <span style={{ fontSize: 12, color: colors.textSecondary }}>{p} / {pages}</span>
        <button style={btn(p >= pages)} disabled={p >= pages} onClick={() => onChange(p + 1)}>Berikutnya ›</button>
      </div>
    </div>
  );
}

const EVENT = {
  connected: { label: 'Terhubung', color: '#059669', bg: 'rgba(16,185,129,0.14)' },
  reconnected: { label: 'Terhubung ulang', color: '#2563EB', bg: 'rgba(37,99,235,0.12)' },
  needs_reconnect: { label: 'Terputus sendiri', color: '#DC2626', bg: 'rgba(239,68,68,0.14)' },
  disconnected: { label: 'Dihapus', color: '#6B7280', bg: 'rgba(107,114,128,0.14)' },
  moved: { label: 'Dipindah', color: '#6B7280', bg: 'rgba(107,114,128,0.14)' },
};
const PLATFORM = { youtube: { icon: 'ti-brand-youtube', color: '#EF4444', label: 'YouTube' }, tiktok: { icon: 'ti-brand-tiktok', color: '#111827', label: 'TikTok' }, instagram: { icon: 'ti-brand-instagram', color: '#E1306C', label: 'Instagram' } };

export function ConnectionHistory({ refreshKey, onConnectYoutube, onReconnectYoutube, onConnectTiktok }) {
  const [platform, setPlatform] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/api/connections/history?page=${page}&limit=${PAGE_SIZE}${platform ? `&platform=${platform}` : ''}`)
      .then(r => { if (alive) setData(r.data); }).catch(() => { if (alive) setData({ items: [], total: 0, pages: 1 }); });
    return () => { alive = false; };
  }, [platform, page, refreshKey]);
  const fmt = iso => new Date(iso).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  const chip = on => ({ fontSize: 12, padding: '4px 10px', borderRadius: 999, cursor: 'pointer', border: `1px solid ${on ? colors.accent : colors.border}`,
    background: on ? colors.accentMuted : colors.bgCard, color: colors.textPrimary });

  return (
    <div style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 16, marginTop: 16 }}>
      <h2 style={{ fontSize: 15, fontWeight: 600, color: colors.textPrimary, margin: 0 }}>🕘 Riwayat koneksi</h2>
      <div style={{ fontSize: 12, color: colors.textSecondary, margin: '4px 0 10px' }}>
        Catatan akun yang terhubung, terputus sendiri (login ditolak platform), atau kamu hapus — supaya mudah diingat dan dihubungkan lagi.
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
        {[['', 'Semua'], ['youtube', 'YouTube'], ['tiktok', 'TikTok'], ['instagram', 'Instagram']].map(([k, l]) => (
          <span key={k || 'all'} style={chip(platform === k)} onClick={() => { setPlatform(k); setPage(1); }}>{l}</span>
        ))}
      </div>
      {!data ? (
        <div style={{ fontSize: 12, color: colors.textSecondary, padding: 8 }}>Memuat riwayat…</div>
      ) : data.items.length === 0 ? (
        <div style={{ fontSize: 12, color: colors.textSecondary, padding: 8 }}>Belum ada catatan. Riwayat mulai tercatat sejak fitur ini aktif.</div>
      ) : (
        <>
          {data.items.map(it => {
            const ev = EVENT[it.event] || EVENT.connected;
            const pf = PLATFORM[it.platform] || PLATFORM.youtube;
            const followUp = it.platform === 'youtube' && it.current_status === 'removed' && (it.event === 'disconnected' || it.event === 'needs_reconnect')
              ? <button className="btn btn-gold" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => onConnectYoutube()}>+ Hubungkan lagi</button>
              : it.platform === 'youtube' && it.current_status === 'needs_reconnect' && it.event === 'needs_reconnect'
                ? <button className="btn" style={{ fontSize: 11, padding: '4px 10px', border: '1px solid #ef4444', color: '#ef4444', background: 'rgba(239,68,68,0.10)', borderRadius: 6 }} onClick={() => onReconnectYoutube(String(it.account_id))}>🔄 Reconnect</button>
                : it.platform === 'tiktok' && it.current_status === 'removed' && it.event === 'disconnected'
                  ? <button className="btn btn-gold" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => onConnectTiktok()}>+ Hubungkan lagi</button>
                  : null;
            return (
              <div key={it.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '9px 0', borderTop: `1px solid ${colors.border}` }}>
                <i className={`ti ${pf.icon}`} style={{ fontSize: 18, color: pf.color, marginTop: 2, flexShrink: 0 }} title={pf.label}></i>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, overflowWrap: 'anywhere' }}>{it.account_name || '(tanpa nama)'}</span>
                    <span style={{ fontSize: 10, fontWeight: 700, color: ev.color, background: ev.bg, borderRadius: 4, padding: '1px 6px' }}>{ev.label}</span>
                  </div>
                  <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 2, overflowWrap: 'anywhere' }}>
                    {fmt(it.created_at)} · {it.source === 'system' ? 'oleh sistem' : 'oleh kamu'}{it.detail ? ` · ${it.detail}` : ''}
                  </div>
                </div>
                {followUp && <div style={{ flexShrink: 0 }}>{followUp}</div>}
              </div>
            );
          })}
          <Pager total={data.total} page={page} onChange={setPage} />
        </>
      )}
    </div>
  );
}
